import api from '@/api'

export default {
  namespaced: true,

  state () {
    return {
      widgets: [],
      loading: 'initial'
    }
  },

  mutations: {
    removeBySlug (state, slug) {
      state.widgets = state.widgets.filter((item) => item.slug !== slug)
    },
    setWidgets (state, widgets) {
      state.widgets = widgets
    },
    startRequest (state) {
      state.loading = 'pending'
    },
    successRequest (state) {
      state.loading = 'idle'
    },
    failedRequest (state) {
      state.loading = 'failed'
    }
  },

  actions: {
    async removeWidget ({ commit, rootGetters }, slug) {
      const { authUserCompany } = rootGetters
      try {
        const response = await api.Widgets.deleteOne(authUserCompany.slug, slug)

        if (response.status === 'success') {
          commit('removeBySlug', slug)
        }

        return response
      } catch (e) {
        console.error(e)
      }

      return {}
    },
    async fetchWidgets ({ commit, rootGetters }) {
      commit('startRequest')
      const { authUserCompany } = rootGetters
      try {
        const response = await api.Widgets.getAll(authUserCompany.slug)
        commit('setWidgets', response.data)
        commit('successRequest')
      } catch (e) {
        console.error(e)
        commit('failedRequest')
      }

    }
  }
}
